import {Button} from "devextreme-react/button";
import {Popup} from "devextreme-react/popup";
import {Layout} from "./Palette";
import Text from "./Text";
import VerticalSpace from "./VerticalSpace";
import {LoadIndicator} from 'devextreme-react/load-indicator';

function Dialog(props) {

    const {openDialog, setOpenDialog, title, onClick, load, text, textButton, width} = props

    return (
        <>
            <Popup
                visible={openDialog}
                onHiding={() => setOpenDialog(false)}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showCloseButton={false}
                showTitle={true}
                title={title}
                width={320}
                height={'auto'}>

                <Text hover={false} size={12} text={text}/>
                <VerticalSpace space={15}/>
                <Layout color="transparent" row center space>
                    <Button
                        width={100}
                        height={30}
                        type="normal"
                        stylingMode="outlined"
                        disabled={load}
                        onClick={() => {
                            setOpenDialog(false)
                        }}
                    >
                        <i className="far fa-arrow-alt-circle-left" style={{fontSize: 12}}/>
                        <span style={{fontSize: 10, fontWeight: 'bold', marginLeft: 5}}>Salir</span>
                    </Button>

                    <Button
                        width={width}
                        height={30}
                        type="success"
                        disabled={load}
                        stylingMode="contained"
                        onClick={onClick}
                    >
                        <Layout color='transparent' center row positionC>
                            {load && <LoadIndicator id="small-indicator" height={15} width={15}/>}
                            {!load && <i className="far fa-check-circle" style={{fontSize: 12}}/>}
                            <span style={{fontSize: '10px', fontWeight: 'bold', marginLeft: 7}}>{textButton}</span>
                        </Layout>
                    </Button>
                </Layout>
            </Popup>
        </>
    )
}

export default Dialog